export enum WarningsEndpointsEnum {
  GET_ALL_WARNINGS = "Warnings/all",
  READ_WARNING = "Warnings/read",
}
